export default __webpack_public_path__ + "static/media/left.446281f3.svg";